module.exports = "<div id=\"injectedUnifiedLogin\">\n</div>\n"


/*****************
 ** WEBPACK FOOTER
 ** ../~/noop-loader!./components/xo-login-components/src/unified-login/template.html
 ** module id = 203
 ** module chunks = 1
 **/